import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import Translatable from '@/components/translatable_text/Translatable'
import { useSelector } from "@/store/Store"
import { cn } from '@/lib/utils'

type Props = {
  title: string;
  open?: boolean;
  setOpen?: (val: boolean) => void;
  subtitle?: string;
  closeBtn?: boolean;
  components?: React.ReactNode;
  trigger?: React.ReactNode;
}


export default function DialogComponent({title, components, subtitle, trigger, open, setOpen, closeBtn = true}: Props) {
  
  const rtl = useSelector((state) => state.customizer.activeDir === 'rtl')
  
  return (

    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent showCloseButton={false}>
        <DialogHeader className={cn(rtl ? `items-end` : 'items-start', "bg-purple text-white px-6 py-6 rounded-md")}>
          <DialogTitle>
            <Translatable>
              {title}
            </Translatable>
          </DialogTitle>
          <DialogDescription className='text-gray-300'>
            <Translatable>
              { subtitle }
            </Translatable>
          </DialogDescription>
        </DialogHeader>

        {components}
        
        {closeBtn && 
          <DialogFooter className="px-6 sm:justify-center">
            <DialogClose asChild>
              <Button className=" w-full" type="button" variant="secondary">
              <Translatable>
                Close
              </Translatable>
              </Button>
            </DialogClose>
          </DialogFooter>
        }
      </DialogContent>
    </Dialog>


  )
}
